import {
    actionCreator,
    checkHttpStatus, 
    jsonApiHeader, 
    showErrorMessage, 
    showSuccessMessage, 
    showWarningMessage,
    skillAcquisitionTargetActionTypes, 
    GET_MASTERDATABYNAME, 
    GET_SKILLACQUISITIONTARGET_LIST_API, 
    POST_SKILLACQUISITIONTARGET_API, 
    DELETE_SKILLACQUISITIONTARGET_API,
    GET_SKILLACQUISITIONTARGET_DETAIL_API,
    TARGET_STATUS_ACTIVATION,
    PATCH_TARGET_STATUS,
    GET_SKILL_ACQ_COLLECTEDDTTDATA_BY_TARGETID,
    GET_SKILL_ACQ_COLLECTED_TA_DATA_BY_TARGETID,
    UPDATE_SKILL_ACQ_COLLECTED_DTT_DATA_STATUS_API,
    UPDATE_SKILL_ACQ_COLLECTED_TA_DATA_STATUS_API,
    UPDATE_SKILL_ACQ_COLLECTED_DTT_DATA_PROMPT_CODE_API,
    UPDATE_SKILL_ACQ_COLLECTED_TA_DATA_PROMPT_CODE_API,
    DELETE_SKILL_ACQ_COLLECTED_DTT_DATA_API,
    DELETE_SKILL_ACQ_COLLECTED_TA_DATA_API,
    POST_COPYPATIENTSKILLACQUISITIONTARGET_API,
    GET_GETPATIENTSKILLACQUISITIONTARGETSINGLEGRAPH_API,
    UPDATE_BATCH_TARGET_STATUS,
    POST_SkillsAcquisitionRawData,
    UPDATE_BATCH_ACTIVE_STATUS,
    POST_RAWSKILLAQUISITIONBEHAVIORDATA_API,
    GET_RAWSKILLAQUISITIONBEHAVIORDATALIST_BY_TARGETID,
    UPDATE_COLLECTEDSKILLAQUISITIONBEHAVIORDATA,
    DELETE_SKILLAQUISITIONBEHAVIORCOLLACTDATA,
    Get_PatientSkillAcqTargets_Data_ForDailySummary
} from '../constants/ApiConstants';
import { reset } from 'redux-form';
import Alert from 'react-s-alert';
import { checkHttpStatusAuthCheck, createSearchUrlForCustomAPI } from '../../../../../../../../actions/utilAction';
import { getSkillAcquisitionProgramList } from '../../Program/actions/skillAquisitionProgramActions';
import { get_patientSkillAcqCollectDataNewFlow, get_patientSkillAcqCollectDataNewFlowAfterEditing } from '../../../../../collectData/componnets/SkillAquisition/components/targets/actions/targetsActionNewFlow';

export const getMasterData = (masterData) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(skillAcquisitionTargetActionTypes.get_masterData.REQUEST));
        fetch(`${GET_MASTERDATABYNAME}`, {
            method: 'post',
            body: JSON.stringify(masterData),
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
            .then(function (response) {
                dispatch(actionCreator(skillAcquisitionTargetActionTypes.get_masterData.SUCCESS, response));
            })
            .catch(function (error) {
                console.log('error getMasterData ..', error);
            });
    };
};

export const getSkillAcquisitionTargetList = (searchObj, patientId, programId,isAllRecordsRequired) => {
    let query_params = createSearchUrlForCustomAPI(searchObj);
    return (dispatch, getState) => {
        dispatch(actionCreator(skillAcquisitionTargetActionTypes.get_skillAcquisitionTargetList.REQUEST));
        fetch(`${GET_SKILLACQUISITIONTARGET_LIST_API}${query_params}&patientId=${patientId}&skillsAcquisitionProgramId=${programId}&isAllRecordsRequired=${isAllRecordsRequired || false}`, {
            method: 'get',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(skillAcquisitionTargetActionTypes.get_skillAcquisitionTargetList.SUCCESS, response));
                } else {
                    dispatch(actionCreator(skillAcquisitionTargetActionTypes.get_skillAcquisitionTargetList.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_skillAcquisitionTargetList', error);
            });
    };
};

export const getSkillAcquisitionTargetListDetails = (skillAcquisitionTargetId) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(skillAcquisitionTargetActionTypes.get_skillAcquisitionTargetDetail.REQUEST));
        fetch(`${GET_SKILLACQUISITIONTARGET_DETAIL_API}?skillAcquisitionTargetId=${skillAcquisitionTargetId}`, {
            method: 'get',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(skillAcquisitionTargetActionTypes.get_skillAcquisitionTargetDetail.SUCCESS, response));
                } else {
                    dispatch(actionCreator(skillAcquisitionTargetActionTypes.get_skillAcquisitionTargetDetail.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_skillAcquisitionTargetDetail', error);
            });
    };
};

export const saveSkillAcquisitionTarget = (formProps) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(skillAcquisitionTargetActionTypes.save_skillAcquisitionTarget.REQUEST));
        fetch(`${POST_SKILLACQUISITIONTARGET_API}`, {
            method: 'POST',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
            body: JSON.stringify(formProps),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    showSuccessMessage(response.message);
                    dispatch(actionCreator(skillAcquisitionTargetActionTypes.save_skillAcquisitionTarget.SUCCESS, response));
                } else {
                    showErrorMessage(response.message);
                    dispatch(actionCreator(skillAcquisitionTargetActionTypes.save_skillAcquisitionTarget.SUCCESS, null));
                }
            })
            .catch(function (error) {
                console.log('error save_skillAcquisitionTarget', error);
            });
    };
};

export const deleteSkillAcquisitionTarget = (targetId, patientId, skillsAcquisitionProgramId) => {
    Alert.closeAll();
    return (dispatch, getState) => {
        dispatch(actionCreator(skillAcquisitionTargetActionTypes.delete_skillAcquisitionTarget.REQUEST));
        fetch(`${DELETE_SKILLACQUISITIONTARGET_API}?targetId=${targetId}`, {
            method: 'PATCH',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then((response) => {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    showSuccessMessage(response.message);
                    dispatch(actionCreator(skillAcquisitionTargetActionTypes.delete_skillAcquisitionTarget.SUCCESS, response));
                    let searchObj = {
                        sort_fields: '',
                        sort_order: '',
                        contain_filters: { SearchText: null },
                        pageNumber: 1,
                    };                    
                    dispatch(getSkillAcquisitionTargetList(searchObj, patientId, skillsAcquisitionProgramId));
                } else if (response.statusCode === 401 || response.statusCode === 422) {
                    showWarningMessage(response.message);
                    dispatch(actionCreator(skillAcquisitionTargetActionTypes.delete_skillAcquisitionTarget.SUCCESS, null));
                } else {
                    showErrorMessage(response.message);
                    dispatch(actionCreator(skillAcquisitionTargetActionTypes.delete_skillAcquisitionTarget.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error delete_skillAcquisitionTarget', error);
            });
    };
};

export const updateTargetActiveStatus = (skillsAcquisitionTargetId, IsActivate, patientId, skillsAcquisitionProgramId) => {
    return (dispatch, getState) => {
      dispatch(actionCreator(skillAcquisitionTargetActionTypes.target_active_status.REQUEST));
      fetch(`${TARGET_STATUS_ACTIVATION}?skillsAcquisitionTargetId=${skillsAcquisitionTargetId}&isActive=${IsActivate}`, {
        method: 'PATCH',
        headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      })
        .then(checkHttpStatus)
        .then(function(response) {
          if (response.statusCode >= 200 && response.statusCode < 204) {
            showSuccessMessage(response.message);
            dispatch(actionCreator(skillAcquisitionTargetActionTypes.target_active_status.SUCCESS, response));
            let searchObj = {
                sort_fields: '',
                sort_order: '',
                contain_filters: { SearchText: null },
                pageNumber: 1,
            };                    
            dispatch(getSkillAcquisitionTargetList(searchObj, patientId, skillsAcquisitionProgramId));
          } else {
            showErrorMessage(response.message);
            dispatch(actionCreator(skillAcquisitionTargetActionTypes.target_active_status.SUCCESS, {}));
          }
        })
        .catch(function(error) {
          console.log('error-----', error);
          dispatch(actionCreator(skillAcquisitionTargetActionTypes.target_active_status.SUCCESS, {}));
        });
    };
  };

  export const updateTargetStatus = (skillsAcquisitionTargetId, statusId, patientId, skillsAcquisitionProgramId, page_number = 1) => {
    return (dispatch, getState) => {
      dispatch(actionCreator(skillAcquisitionTargetActionTypes.patch_target__status.REQUEST));
      fetch(`${PATCH_TARGET_STATUS}?skillsAcquisitionTargetId=${skillsAcquisitionTargetId}&statusId=${statusId}`, {
        method: 'PATCH',
        headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      })
        .then(checkHttpStatus)
        .then(function(response) {
          if (response.statusCode >= 200 && response.statusCode < 204) {
            showSuccessMessage(response.message);
            dispatch(actionCreator(skillAcquisitionTargetActionTypes.patch_target__status.SUCCESS, response));
            let searchObj = {
                sort_fields: '',
                sort_order: '',
                contain_filters: { SearchText: null },
                pageNumber: page_number,
            };                    
            dispatch(getSkillAcquisitionTargetList(searchObj, patientId, skillsAcquisitionProgramId));
          } else {
            showErrorMessage(response.message);
            dispatch(actionCreator(skillAcquisitionTargetActionTypes.patch_target__status.SUCCESS, {}));
          }
        })
        .catch(function(error) {
          console.log('error-----', error);
          dispatch(actionCreator(skillAcquisitionTargetActionTypes.target_active_status.SUCCESS, {}));
        });
    };
  };


  export const getSkillAcquisitionCollectedDTTDataByTargetIDAction = (patientId, targetId, skillsAcquisitionProgramId, searchObj) => {
    let query_params = createSearchUrlForCustomAPI(searchObj);
    return (dispatch, getState) => {
        dispatch(actionCreator(skillAcquisitionTargetActionTypes.get_skillAcqCollectedDTTDataBytTargetId.REQUEST));
        fetch(`${GET_SKILL_ACQ_COLLECTEDDTTDATA_BY_TARGETID}${query_params}&patientId=${patientId}&targetId=${targetId}&skillsAcquisitionProgramId=${skillsAcquisitionProgramId}`, {
            method: 'get',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(skillAcquisitionTargetActionTypes.get_skillAcqCollectedDTTDataBytTargetId.SUCCESS, response));
                } else {
                    dispatch(actionCreator(skillAcquisitionTargetActionTypes.get_skillAcqCollectedDTTDataBytTargetId.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_skillAcqCollectedDTTDataBytTargetId', error);
            });
    };
};



export const getSkillAcquisitionCollectedTADataByTargetIDAction = (patientId, targetId, skillsAcquisitionProgramId, searchObj) => {
    let query_params = createSearchUrlForCustomAPI(searchObj);
    return (dispatch, getState) => {
        dispatch(actionCreator(skillAcquisitionTargetActionTypes.get_skillAcqCollectedTADataBytTargetId.REQUEST));
        fetch(`${GET_SKILL_ACQ_COLLECTED_TA_DATA_BY_TARGETID}${query_params}&patientId=${patientId}&targetId=${targetId}&skillsAcquisitionProgramId=${skillsAcquisitionProgramId}`, {
            method: 'get',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(skillAcquisitionTargetActionTypes.get_skillAcqCollectedTADataBytTargetId.SUCCESS, response));
                } else {
                    dispatch(actionCreator(skillAcquisitionTargetActionTypes.get_skillAcqCollectedTADataBytTargetId.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_skillAcqCollectedTADataBytTargetId', error);
            });
    };
};


export const updateSkillAcaCollectedDTTDataAction = (collectedDataId, sessionDate, staffId, statusId, patientId, skillsAcquisitionProgramId, targetId, action) => {
    return (dispatch, getState) => {
      dispatch(actionCreator(skillAcquisitionTargetActionTypes.update_skillAcqCollectedDTTDataStatus.REQUEST));
      fetch(`${UPDATE_SKILL_ACQ_COLLECTED_DTT_DATA_STATUS_API}?collectedDataId=${collectedDataId}&sessionDate=${sessionDate}&staffId=${staffId}&statusId=${statusId}&patientId=${patientId}&actionName=${action}`, {
        method: 'PATCH',
        headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      })
        .then(checkHttpStatus)
        .then(function(response) {
          if (response.statusCode >= 200 && response.statusCode < 204) {
            showSuccessMessage(response.message);
            dispatch(actionCreator(skillAcquisitionTargetActionTypes.update_skillAcqCollectedDTTDataStatus.SUCCESS, response));
            let searchObj = {
                sort_fields: '',
                sort_order: '',
                contain_filters: null ,
                pageNumber: 1,
            };
            dispatch(getSkillAcquisitionCollectedDTTDataByTargetIDAction(patientId, targetId, skillsAcquisitionProgramId,searchObj))
          } else {
            showErrorMessage(response.message);
            dispatch(actionCreator(skillAcquisitionTargetActionTypes.update_skillAcqCollectedDTTDataStatus.SUCCESS, {}));
          }
        })
        .catch(function(error) {
          console.log('error-----', error);
          dispatch(actionCreator(skillAcquisitionTargetActionTypes.update_skillAcqCollectedDTTDataStatus.SUCCESS, {}));
        });
    };
  };

  export const updateSkillAcaCollectedTADataAction = (taskAnalysisId, sessionDate, staffId, statusId, patientId, skillsAcquisitionProgramId, targetId, action) => {
    return (dispatch, getState) => {
      dispatch(actionCreator(skillAcquisitionTargetActionTypes.update_skillAcqCollectedTADataStatus.REQUEST));
      fetch(`${UPDATE_SKILL_ACQ_COLLECTED_TA_DATA_STATUS_API}?taskAnalysisId=${taskAnalysisId}&sessionDate=${sessionDate}&staffId=${staffId}&statusId=${statusId}&patientId=${patientId}&actionName=${action}`, {
        method: 'PATCH',
        headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      })
        .then(checkHttpStatus)
        .then(function(response) {
          if (response.statusCode >= 200 && response.statusCode < 204) {
            showSuccessMessage(response.message);
            dispatch(actionCreator(skillAcquisitionTargetActionTypes.update_skillAcqCollectedTADataStatus.SUCCESS, response));
            let searchObj = {
                sort_fields: '',
                sort_order: '',
                contain_filters: null,
                pageNumber:1,
            };
            dispatch(getSkillAcquisitionCollectedTADataByTargetIDAction(patientId, targetId, skillsAcquisitionProgramId, searchObj))
          } else {
            showErrorMessage(response.message);
            dispatch(actionCreator(skillAcquisitionTargetActionTypes.update_skillAcqCollectedTADataStatus.SUCCESS, {}));
          }
        })
        .catch(function(error) {
          console.log('error-----', error);
          dispatch(actionCreator(skillAcquisitionTargetActionTypes.update_skillAcqCollectedTADataStatus.SUCCESS, {}));
        });
    };
  };

  export const updateSkillAcqCollectedDTTDataPromtCodeAction = (collectedDataId, promptCodeId, patientId, skillsAcquisitionProgramId, targetId) => {
    return (dispatch, getState) => {
      dispatch(actionCreator(skillAcquisitionTargetActionTypes.update_skillAcqCollectedDTTDataPromtCode.REQUEST));
      fetch(`${UPDATE_SKILL_ACQ_COLLECTED_DTT_DATA_PROMPT_CODE_API}?collectedDataId=${collectedDataId}&promptCodeId=${promptCodeId}&patientId=${patientId}`, {
        method: 'PATCH',
        headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      })
        .then(checkHttpStatus)
        .then(function(response) {
          if (response.statusCode >= 200 && response.statusCode < 204) {
            showSuccessMessage(response.message);
            dispatch(actionCreator(skillAcquisitionTargetActionTypes.update_skillAcqCollectedDTTDataPromtCode.SUCCESS, response));
            let searchObj = {
                sort_fields: '',
                sort_order: '',
                contain_filters: null,
                pageNumber:1,
            };
            dispatch(getSkillAcquisitionCollectedDTTDataByTargetIDAction(patientId, targetId, skillsAcquisitionProgramId,searchObj))
          } else {
            showErrorMessage(response.message);
            dispatch(actionCreator(skillAcquisitionTargetActionTypes.update_skillAcqCollectedDTTDataPromtCode.SUCCESS, {}));
          }
        })
        .catch(function(error) {
          console.log('error-----', error);
          dispatch(actionCreator(skillAcquisitionTargetActionTypes.update_skillAcqCollectedDTTDataPromtCode.SUCCESS, {}));
        });
    };
  };

  export const updateSkillAcqCollectedTADataPromtCodeAction = (taskAnalysisId, promptCodeId, patientId, skillsAcquisitionProgramId, targetId) => {
    return (dispatch, getState) => {
      dispatch(actionCreator(skillAcquisitionTargetActionTypes.update_skillAcqCollectedTADataPromtCode.REQUEST));
      fetch(`${UPDATE_SKILL_ACQ_COLLECTED_TA_DATA_PROMPT_CODE_API}?taskAnalysisId=${taskAnalysisId}&promptCodeId=${promptCodeId}&patientId=${patientId}`, {
        method: 'PATCH',
        headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      })
        .then(checkHttpStatus)
        .then(function(response) {
          if (response.statusCode >= 200 && response.statusCode < 204) {
            showSuccessMessage(response.message);
            dispatch(actionCreator(skillAcquisitionTargetActionTypes.update_skillAcqCollectedTADataPromtCode.SUCCESS, response));
            let searchObj = {
                sort_fields: '',
                sort_order: '',
                contain_filters: null,
                pageNumber:1,
            };
            dispatch(getSkillAcquisitionCollectedTADataByTargetIDAction(patientId, targetId, skillsAcquisitionProgramId,searchObj))
          } else {
            showErrorMessage(response.message);
            dispatch(actionCreator(skillAcquisitionTargetActionTypes.update_skillAcqCollectedTADataPromtCode.SUCCESS, {}));
          }
        })
        .catch(function(error) {
          console.log('error-----', error);
          dispatch(actionCreator(skillAcquisitionTargetActionTypes.update_skillAcqCollectedTADataPromtCode.SUCCESS, {}));
        });
    };
  };


  
  export const deleteSkillAcqCollectedDTTData = (collectedDataIds,patientId, skillsAcquisitionProgramId, targetId) => {
    return (dispatch, getState) => {
      dispatch(actionCreator(skillAcquisitionTargetActionTypes.delete_skillAcqCollectedDTTData.REQUEST));
      fetch(`${DELETE_SKILL_ACQ_COLLECTED_DTT_DATA_API}?collectedDataIds=${collectedDataIds}`, {
        method: 'PATCH',
        headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      })
        .then(checkHttpStatus)
        .then(function(response) {
          if (response.statusCode >= 200 && response.statusCode < 204) {
            showSuccessMessage(response.message);
            dispatch(actionCreator(skillAcquisitionTargetActionTypes.delete_skillAcqCollectedDTTData.SUCCESS, response));
            let searchObj = {
                sort_fields: '',
                sort_order: '',
                contain_filters: null,
                pageNumber:1,
            };
            dispatch(getSkillAcquisitionCollectedDTTDataByTargetIDAction(patientId, targetId, skillsAcquisitionProgramId,searchObj))
          } else {
            showErrorMessage(response.message);
            dispatch(actionCreator(skillAcquisitionTargetActionTypes.delete_skillAcqCollectedDTTData.SUCCESS, {}));
          }
        })
        .catch(function(error) {
          console.log('error-----', error);
          dispatch(actionCreator(skillAcquisitionTargetActionTypes.delete_skillAcqCollectedDTTData.SUCCESS, {}));
        });
    };
  };

  
  export const deleteSkillAcqCollectedTAData = (taskAnalysisIds,patientId, skillsAcquisitionProgramId, targetId) => {
    return (dispatch, getState) => {
      dispatch(actionCreator(skillAcquisitionTargetActionTypes.delete_skillAcqCollectedTAData.REQUEST));
      fetch(`${DELETE_SKILL_ACQ_COLLECTED_TA_DATA_API}?taskAnalysisIds=${taskAnalysisIds}`, {
        method: 'PATCH',
        headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      })
        .then(checkHttpStatus)
        .then(function(response) {
          if (response.statusCode >= 200 && response.statusCode < 204) {
            showSuccessMessage(response.message);
            dispatch(actionCreator(skillAcquisitionTargetActionTypes.delete_skillAcqCollectedTAData.SUCCESS, response));
            let searchObj = {
                sort_fields: '',
                sort_order: '',
                contain_filters: null,
                pageNumber:1,
            };
            dispatch(getSkillAcquisitionCollectedTADataByTargetIDAction(patientId, targetId, skillsAcquisitionProgramId,searchObj))
            dispatch(reset('RawDataTAModalForm'));
          } else {
            showErrorMessage(response.message);
            dispatch(actionCreator(skillAcquisitionTargetActionTypes.delete_skillAcqCollectedTAData.SUCCESS, {}));
          }
        })
        .catch(function(error) {
          console.log('error-----', error);
          dispatch(actionCreator(skillAcquisitionTargetActionTypes.delete_skillAcqCollectedTAData.SUCCESS, {}));
        });
    };
  };

  export const copyPatientSkillAcquisitionTarget = (formProps, patientId, skillsAcquisitionProgramId) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(skillAcquisitionTargetActionTypes.save_copyPatientSkillAcquisitionTarget.REQUEST));
        fetch(`${POST_COPYPATIENTSKILLACQUISITIONTARGET_API}`, {
            method: 'POST',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
            body: JSON.stringify(formProps),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    showSuccessMessage(response.message);
                    dispatch(actionCreator(skillAcquisitionTargetActionTypes.save_copyPatientSkillAcquisitionTarget.SUCCESS, response));
                    let searchObj = {
                      sort_fields: '',
                      sort_order: '',
                      contain_filters: { SearchText: null },
                      pageNumber: 1,
                  };                    
                  dispatch(getSkillAcquisitionTargetList(searchObj, patientId, skillsAcquisitionProgramId));
                } else {
                    showErrorMessage(response.message);
                    dispatch(actionCreator(skillAcquisitionTargetActionTypes.save_copyPatientSkillAcquisitionTarget.SUCCESS, null));
                }
            })
            .catch(function (error) {
                console.log('error save_copyPatientSkillAcquisitionTarget', error);
            });
    };
};

export const getPatientSkillAcquisitionTargetSingleGraph = (patientId, targetTypeName, skillAcquisitionTargetId, skillsAcquisitionProgramId, FromDate, ToDate, graphByStaff, graphType) => {
  return (dispatch, getState) => {
      dispatch(actionCreator(skillAcquisitionTargetActionTypes.get_getPatientSkillAcquisitionTargetSingleGraph.REQUEST));
      fetch(`${GET_GETPATIENTSKILLACQUISITIONTARGETSINGLEGRAPH_API}?patientId=${patientId}&targetTypeName=${targetTypeName}&skillAcquisitionTargetId=${skillAcquisitionTargetId}&skillsAcquisitionProgramId=${skillsAcquisitionProgramId}&fromDate=${FromDate}&toDate=${ToDate}&graphByStaff=${graphByStaff}&graphType=${graphType}`, {
          method: 'GET',
          headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      })
          .then(checkHttpStatus)
          .then(function (response) {
              if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                  dispatch(actionCreator(skillAcquisitionTargetActionTypes.get_getPatientSkillAcquisitionTargetSingleGraph.SUCCESS, response));
              } else {
                  dispatch(actionCreator(skillAcquisitionTargetActionTypes.get_getPatientSkillAcquisitionTargetSingleGraph.SUCCESS, null));
              }
          }).catch(function (error) {
              console.log('error get_getPatientSkillAcquisitionTargetSingleGraph', error);
          });
  };
};


export const updateBatchTargetStatus = (skillsAcquisitionTargetIds, targetStatusId, patientId, skillsAcquisitionProgramId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(skillAcquisitionTargetActionTypes.update_batch_target_status.REQUEST));
    fetch(`${UPDATE_BATCH_TARGET_STATUS}?skillsAcquisitionTargetIds=${skillsAcquisitionTargetIds}&targetStatusId=${targetStatusId}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(skillAcquisitionTargetActionTypes.update_batch_target_status.SUCCESS, response));

          let searchObj = {
            sort_fields: '',
            sort_order: '',
            contain_filters: { SearchText: null },
            pageNumber: 1,
        };

          dispatch(getSkillAcquisitionTargetList(searchObj, patientId, skillsAcquisitionProgramId))
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(skillAcquisitionTargetActionTypes.update_batch_target_status.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error update_batch_claims_payment_status...', error);
      });
  };
};


export const updateBatchActiveStatus = (skillsAcquisitionIds, statusId, patientId, skillsAcquisitionProgramId,targetType,domainId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(skillAcquisitionTargetActionTypes.update_batch_active_status.REQUEST));
    fetch(`${UPDATE_BATCH_ACTIVE_STATUS}?skillsAcquisitionIds=${skillsAcquisitionIds}&statusId=${statusId}&targetType=${targetType}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(skillAcquisitionTargetActionTypes.update_batch_active_status.SUCCESS, response));

          if(targetType)
          {
            let searchObj = {
              sort_fields: '',
              sort_order: '',
              contain_filters: { SearchText: null },
              pageNumber: 1,
            };
            dispatch(getSkillAcquisitionTargetList(searchObj, patientId, skillsAcquisitionProgramId));
         }
         else
         {
            let searchObj1 = {
                sort_fields: '',
                sort_order: '',
                contain_filters: { SearchText: null },
                pageNumber: 1,
            };
            dispatch(getSkillAcquisitionProgramList(searchObj1, patientId, domainId));
         }

        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(skillAcquisitionTargetActionTypes.update_batch_active_status.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error update_batch_claims_payment_status...', error);
      });
  };
};

export const saveSkillsAcquisitionRawData = (formProps) => {
  return (dispatch, getState) => {
      dispatch(actionCreator(skillAcquisitionTargetActionTypes.save_SkillsAcquisitionRawData.REQUEST));
      fetch(`${POST_SkillsAcquisitionRawData}`, {
          method: 'POST',
          headers: jsonApiHeader(getState().login.access_token, 'application/json'),
          body: JSON.stringify(formProps),
      })
          .then(checkHttpStatus)
          .then(function (response) {
              if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                  showSuccessMessage(response.message);
                  dispatch(actionCreator(skillAcquisitionTargetActionTypes.save_SkillsAcquisitionRawData.SUCCESS, response));
              } else {
                  showErrorMessage(response.message);
                  dispatch(actionCreator(skillAcquisitionTargetActionTypes.save_SkillsAcquisitionRawData.SUCCESS, null));
              }
          })
          .catch(function (error) {
              console.log('error save_SkillsAcquisitionRawData', error);
          });
  };
};

export const SaveRawSkillAquisitionBehaviorData = (formProps, patientId) => {
  return (dispatch, getState) => {
      dispatch(actionCreator(skillAcquisitionTargetActionTypes.save_rawskillaquisitionbehaviordata.REQUEST));
      fetch(`${POST_RAWSKILLAQUISITIONBEHAVIORDATA_API}`, {
          method: 'POST',
          headers: jsonApiHeader(getState().login.access_token, 'application/json'),
          body: JSON.stringify(formProps),
      })
          .then(checkHttpStatus)
          .then(function (response) {
              if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                  showSuccessMessage(response.message);
                  dispatch(actionCreator(skillAcquisitionTargetActionTypes.save_rawskillaquisitionbehaviordata.SUCCESS, response));                  
              } else {
                  showErrorMessage(response.message);
                  dispatch(actionCreator(skillAcquisitionTargetActionTypes.save_rawskillaquisitionbehaviordata.SUCCESS, null));
              }
          })
          .catch(function (error) {
              console.log('error save_rawskillaquisitionbehaviordata', error);
          });
  };
};



export const getPatientSkillAquisitionBehaviorCollectDataList = (searchObj) => {
  let query_params = createSearchUrlForCustomAPI(searchObj);
  return (dispatch, getState) => {
      dispatch(actionCreator(skillAcquisitionTargetActionTypes.get_skillAcquisitionBehaviorCollactDataListByTargetId.REQUEST));
      fetch(`${GET_RAWSKILLAQUISITIONBEHAVIORDATALIST_BY_TARGETID}${query_params}`, {
          method: 'get',
          headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      })
          .then(checkHttpStatus)
          .then(function (response) {
              if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                  dispatch(actionCreator(skillAcquisitionTargetActionTypes.get_skillAcquisitionBehaviorCollactDataListByTargetId.SUCCESS, response));
              } else {
                  dispatch(actionCreator(skillAcquisitionTargetActionTypes.get_skillAcquisitionBehaviorCollactDataListByTargetId.SUCCESS, null));
              }
          }).catch(function (error) {
              console.log('error get_behaviorCollactDataListByBehaviorId', error);
          });
  };
};


export const deleteSkillAquisitionBehaviorCollactData = (selectedRecordDataIds, recordingTypeName, patientId, skillsAcquisitionProgramId, skillsAcquisitionTargetId,screenName, duration = null) => {
  Alert.closeAll();
  return (dispatch, getState) => {
      dispatch(actionCreator(skillAcquisitionTargetActionTypes.delete_skillAquisitionBehaviorCollactData.REQUEST));
      fetch(`${DELETE_SKILLAQUISITIONBEHAVIORCOLLACTDATA}?selectedRecordDataIds=${selectedRecordDataIds}&recordingTypeName=${recordingTypeName}&value=${duration},&screenName=${screenName}`, {
          method: 'PATCH',
          headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      })
          .then(checkHttpStatus)
          .then((response) => {
              if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                  showSuccessMessage(response.message);
                  dispatch(actionCreator(skillAcquisitionTargetActionTypes.delete_skillAquisitionBehaviorCollactData.SUCCESS, response));
                  let searchObj = {
                      sort_fields: '',
                      sort_order: '',
                      contain_filters: { 
                              searchText: null, 
                              patientId: patientId, 
                              skillsAcquisitionProgramId: skillsAcquisitionProgramId,
                              skillsAcquisitionTargetId: skillsAcquisitionTargetId,         
                              recordingTypeName: recordingTypeName
                           },
                      pageNumber: 1,
                  };
                  dispatch(getPatientSkillAquisitionBehaviorCollectDataList(searchObj));
                  
              } else if (response.statusCode === 401 || response.statusCode === 422) {
                  showWarningMessage(response.message);
                  dispatch(actionCreator(skillAcquisitionTargetActionTypes.delete_skillAquisitionBehaviorCollactData.SUCCESS, null));
              } else {
                  showErrorMessage(response.message);
                  dispatch(actionCreator(skillAcquisitionTargetActionTypes.delete_skillAquisitionBehaviorCollactData.SUCCESS, null));
              }
          }).catch(function (error) {
              console.log('error delete_skillAquisitionBehaviorCollactData', error);
          });
  };
};


export const deleteSkillAquisitionBehaviorCollactDataForTodaysData = (selectedRecordDataIds, recordingTypeName, patientId, skillsAcquisitionProgramId, skillsAcquisitionTargetId, duration = null, searchObj, dataForFilter,screenName) => {
  Alert.closeAll();
  return (dispatch, getState) => {
      //dispatch(actionCreator(skillAcquisitionTargetActionTypes.delete_skillAquisitionBehaviorCollactData.REQUEST));
      fetch(`${DELETE_SKILLAQUISITIONBEHAVIORCOLLACTDATA}?selectedRecordDataIds=${selectedRecordDataIds}&recordingTypeName=${recordingTypeName}&value=${duration},&screenName=${screenName}`, {
          method: 'PATCH',
          headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      })
          .then(checkHttpStatus)
          .then((response) => {
              if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                  showSuccessMessage(response.message);
                  //dispatch(actionCreator(skillAcquisitionTargetActionTypes.delete_skillAquisitionBehaviorCollactData.SUCCESS, response));
                  dispatch(get_patientSkillAcqCollectDataNewFlowAfterEditing(searchObj, dataForFilter));          
                  
              } else if (response.statusCode === 401 || response.statusCode === 422) {
                  showWarningMessage(response.message);
                  //dispatch(actionCreator(skillAcquisitionTargetActionTypes.delete_skillAquisitionBehaviorCollactData.SUCCESS, null));
              } else {
                  showErrorMessage(response.message);
                  //dispatch(actionCreator(skillAcquisitionTargetActionTypes.delete_skillAquisitionBehaviorCollactData.SUCCESS, null));
              }
          }).catch(function (error) {
              console.log('error delete_skillAquisitionBehaviorCollactData', error);
          });
  };
};


export const updateCollectedSkillAquisitionBehaviorData = (collectedDataId, recordDataDetailId, sessionDate, staffId, value, duration, patientId, skillsAcquisitionProgramId, skillsAcquisitionTargetId, action, recordingTypeName, screenName) => {
  return (dispatch, getState) => {    
    dispatch(actionCreator(skillAcquisitionTargetActionTypes.update_collectedSkillAquisitionBehaviorDataStatus.REQUEST));
    fetch(`${UPDATE_COLLECTEDSKILLAQUISITIONBEHAVIORDATA}?collectedDataId=${collectedDataId}&recordDataDetailId=${recordDataDetailId}&sessionDate=${sessionDate}&staffId=${staffId}&value=${value}&duration=${duration}&patientId=${patientId}&actionName=${action}&recordingTypeName=${recordingTypeName}&screenName=${screenName}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 204) {
          showSuccessMessage(response.message);   
            let searchObj = {
              sort_fields: '',
              sort_order: '',
              contain_filters: { 
                      searchText: null, 
                      patientId: patientId, 
                      skillsAcquisitionProgramId: skillsAcquisitionProgramId,
                      skillsAcquisitionTargetId: skillsAcquisitionTargetId,         
                      recordingTypeName: recordingTypeName
                  },
              pageNumber: 1,
          };
          dispatch(getPatientSkillAquisitionBehaviorCollectDataList(searchObj))
          
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(skillAcquisitionTargetActionTypes.update_collectedSkillAquisitionBehaviorDataStatus.SUCCESS, {}));
        }
      })
      .catch(function(error) {
        console.log('error-----', error);
        dispatch(actionCreator(skillAcquisitionTargetActionTypes.update_collectedSkillAquisitionBehaviorDataStatus.SUCCESS, {}));
      });
  };
};

export const updateCollectedSkillAquisitionBehaviorDataForTodaysData = (collectedDataId, recordDataDetailId, sessionDate, staffId, value, duration, patientId, action, recordingTypeName, searchObj, dataForFilter,screenName) => {
  return (dispatch, getState) => {    
   // dispatch(actionCreator(skillAcquisitionTargetActionTypes.update_collectedSkillAquisitionBehaviorDataStatus.REQUEST));
    fetch(`${UPDATE_COLLECTEDSKILLAQUISITIONBEHAVIORDATA}?collectedDataId=${collectedDataId}&recordDataDetailId=${recordDataDetailId}&sessionDate=${sessionDate}&staffId=${staffId}&value=${value}&duration=${duration}&patientId=${patientId}&actionName=${action}&recordingTypeName=${recordingTypeName}&screenName=${screenName}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 204) {
          showSuccessMessage(response.message);   
          dispatch(get_patientSkillAcqCollectDataNewFlowAfterEditing(searchObj, dataForFilter));          
        } else {
          showErrorMessage(response.message);
          //dispatch(actionCreator(skillAcquisitionTargetActionTypes.update_collectedSkillAquisitionBehaviorDataStatus.SUCCESS, {}));
        }
      })
      .catch(function(error) {
        console.log('error-----', error);
        //dispatch(actionCreator(skillAcquisitionTargetActionTypes.update_collectedSkillAquisitionBehaviorDataStatus.SUCCESS, {}));
      });
  };
};


export const getPatientSkillAcqReductionForDailySummary = (patientId,skillsAcquisitionTargetId,Date) => {
  return (dispatch, getState) => {
      dispatch(actionCreator(skillAcquisitionTargetActionTypes.get_PatientSkillAcqTargets_Data_ForDailySummary.REQUEST));
      fetch(`${Get_PatientSkillAcqTargets_Data_ForDailySummary}?patientId=${patientId}&skillsAcquisitionTargetId=${skillsAcquisitionTargetId}&sessionDate=${Date}`, {
          method: 'GET',
          headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      })
          .then(checkHttpStatus)
          .then(function (response) {
              if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                  dispatch(actionCreator(skillAcquisitionTargetActionTypes.get_PatientSkillAcqTargets_Data_ForDailySummary.SUCCESS, response));
              } else {
                  dispatch(actionCreator(skillAcquisitionTargetActionTypes.get_PatientSkillAcqTargets_Data_ForDailySummary.SUCCESS, null));
              }
          }).catch(function (error) {
              console.log('error get_behaviourReductionSingleGraph', error);
          });
  };
};

export const setIsEventOccureSkillAcqFalse = () => {
  return (dispatch,getstate)=>{
    dispatch(actionCreator(skillAcquisitionTargetActionTypes.setIsEventOccureSkillAcqFalse.SUCCESS));
  }
}

export const setIsEventOccureSABCollactDataListByTargetIdFalse = () => {
  return (dispatch)=>{
    dispatch(actionCreator(skillAcquisitionTargetActionTypes.setIsEventOccureSABCollactDataListByTargetIdFalse.SUCCESS));
  }
}




// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/SkillAquisition/components/Target/actions/skillAquisitionTargetActions.js